import { c as _c } from "react/compiler-runtime";
import React, { forwardRef } from 'react';
import { StyledTabs } from './styles';
import { type TabsProps } from './types';
import { TABS_CLASS_NAME, TABS_FLEX_CONTAINER_CLASS_NAME } from './classnames';
const Tabs = forwardRef<HTMLDivElement, TabsProps>((t0, ref) => {
  const $ = _c(16);
  let children;
  let handleChange;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      variant: t1,
      size: t2,
      handleChange,
      currentTab: t3,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = handleChange;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    children = $[1];
    handleChange = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const variant = t1 === undefined ? "standard" : t1;
  const size = t2 === undefined ? "large" : t2;
  const currentTab = t3 === undefined ? 0 : t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      flexContainer: TABS_FLEX_CONTAINER_CLASS_NAME
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children || $[9] !== currentTab || $[10] !== handleChange || $[11] !== props || $[12] !== ref || $[13] !== size || $[14] !== variant) {
    t5 = <StyledTabs className={TABS_CLASS_NAME} classes={t4} value={currentTab} variant={variant} size={size} {...props} onChange={handleChange} ref={ref}>{children}</StyledTabs>;
    $[8] = children;
    $[9] = currentTab;
    $[10] = handleChange;
    $[11] = props;
    $[12] = ref;
    $[13] = size;
    $[14] = variant;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
});
export default Tabs;
export { Tabs };